jQuery(function(){
  // ======== Product page gallery ========
  var plusProductImageGallery = '.plus-product-images__gallery',
      plusProductImageLarge = '.plus-product-images__large',
      plusProductImageThumbnail = '.plus-product-images__thumbnails .thumbnail'

  if (jQuery(plusProductImageGallery).length > 0) {
    jQuery(plusProductImageLarge).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: true,
      draggable: false,
      adaptiveHeight: false,
      responsive: [
          {
              breakpoint: 600,
              settings: {
                  adaptiveHeight: true,
                  arrows: false,
              }
          }
      ]
    });

    jQuery(plusProductImageThumbnail).click(function() {
      var slideIndex = parseInt(jQuery(this).index());
      jQuery(plusProductImageThumbnail).removeClass('active');
      jQuery(plusProductImageLarge).slick('slickGoTo', slideIndex);
      jQuery(this).addClass('active');
    });

    jQuery(window).resize(function(){
      jQuery(plusProductImageLarge).slick.refresh();
    });
  }
});